export const getShareVehiclesModalData = (state) => state.vehicleDetails.shareVehicles;
export const getVehicleRemark = (state) => state.vehicleDetails.remark;
export const getVehicleDetailsData = (state) => state.vehicleDetails.details;
export const getVehiclePositionStatisticsHistory = (state) => state.vehicleDetails.positions.statistics;
export const getGenerateReportModalData = (state) => state.vehicleDetails.generateReport;
export const getVehicleDrivingTimes = (state) => state.vehicleDetails.drivingTimes;

export const getVehicleIdsWithDriveTime = (state) => state.vehicleDetails.vehiclesWithDriveTime.idSet;
